import { Directive, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Directive()
export class DestroyableComponent implements OnDestroy {
  protected onDestroy = new Subject<void>();

  ngOnDestroy() {
    this.onDestroy.next(undefined);
    this.onDestroy.complete();
  }
}
